import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";

const TrackOrder: React.FC = () => {
  const trackingUrl = `https://nmsui-wa-prod-san-fqd3aqczgsffczha.southafricanorth-01.azurewebsites.net/sodastream-tracking?waybillNumber=`;

  return (
    <>
      <div className="bg-white sm:mt-[5%] mt-[20%]">
        <Navbar />
        <div className="tracking-page">
          <div className="tracking-frame-container ">
            <iframe
              src={trackingUrl}
              title="SodaStream Tracking"
              width="100%"
              height="600px"
              style={{ border: "none" }}
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TrackOrder;

// import React, { useState } from "react";
// import Header from "../../components/Header/Header";
// import { Images } from "../../assets/assets";
// import Footer from "../../components/Footer/Footer";
// import SecondaryButton from "../../components/Button/SecondaryButton";
// import orderHistoryServiceInstance from "../../APIs/orderHistory";

// // Import icons
// import {
//   FaBoxOpen,
//   FaBox,
//   FaTruck,
//   FaShippingFast,
//   FaRegClock,
//   FaCheckCircle
// } from "react-icons/fa";

// const steps = [
//   {
//     title: "Order Received",
//     description: "Your order has been received and is being processed.",
//     icon: <FaBox className="text-2xl" />
//   },
//   {
//     title: "Order Packed",
//     description: "Your order has been packed and is ready for dispatch.",
//     icon: <FaBoxOpen className="text-2xl" />
//   },
//   {
//     title: "Collected by Courier",
//     description: "Your order has been collected by the courier and is on the way.",
//     icon: <FaRegClock className="text-2xl" />
//   },
//   {
//     title: "In Transit",
//     description: "Your order is currently in transit to the destination.",
//     icon: <FaTruck className="text-2xl" />
//   },
//   {
//     title: "Out for Delivery",
//     description: "Your order is out for delivery and will arrive soon.",
//     icon: <FaShippingFast className="text-2xl" />
//   },
//   {
//     title: "Delivered",
//     description: "Your order has been delivered. Thank you for shopping with us!",
//     icon: <FaCheckCircle className="text-2xl" />
//   }
// ];

// const TrackOrder = () => {
//   const [trackingNumber, setTrackingNumber] = useState("");
//   const [orderStatuses, setOrderStatuses] = useState<any>(null);
//   const [error, setError] = useState<string | null>(null);
//   const [loading, setLoading] = useState(false);

//   const handleTrackOrder = async () => {

//     const trimmedTrackingNumber = trackingNumber.trim();

//     setLoading(true);
//     try {
//       const response = await orderHistoryServiceInstance.getLatestOrderHistory(
//         trimmedTrackingNumber
//       );
//       if (response.data) {
//         const sortedStatuses = response.data.sort(
//           (a: any, b: any) =>
//             new Date(a.timestamp).getTime() - new Date(b.timestamp).getTime()
//         );
//         setOrderStatuses(sortedStatuses);

//         setError(null);
//       } else {
//         setOrderStatuses(null);
//         setError("No orders found for the given tracking number.");
//       }
//     } catch (error: any) {
//       setOrderStatuses(null);
//       setError("An error occurred while fetching the order.");
//       console.error("Error tracking order:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const getCurrentStep = () => {
//     if (!orderStatuses || orderStatuses.length === 0) return 0;
//     const lastEventDescription = orderStatuses[orderStatuses.length - 1].eventdescription; // lowercase property name

//     switch (lastEventDescription) {
//       case "order_received":
//         return 0;
//       case "Order Packed":
//         return 1;
//       case "Collected by Courier":
//         return 2;
//       case "In Transit":
//         return 3;
//       case "Out for Delivery":
//         return 4;
//       case "Delivered":
//         return 5;
//       default:
//         return 0;
//     }
//   };
//   return (
//     <>
//     <Header
//         backgroundImg={Images.Page19BG}
//         title="Track your SodaStream order"
//         textBackground="TRACKING"
//         desktopHeight="95vh"
//         mobileTextMargin="-50%"

//         mobileTitleMargin="12%"
//       />
//     <div>

//       <section className="px-10 py-20 relative w-full mt-[-72%] md:mt-[-39%] z-30 md:mb-[80px] ">
//         <div className="relative min-h-[0rem] w-full bg-transparent">
//           <div className="relative gap-10 md:z-50 z-9 flex flex-col
//            items-start justify-center
//            w-full">
//             <div className="mt-[150px] sm:mt-[100px] flex flex-col items-start justify-start md:w-full md:px-60">

//               <p className="text-[14px] text-white">
//                 Fill out the information below:
//               </p>
//             </div>
//             <div className="flex flex-col md:flex-row gap-4 w-full px-5 md:px-60">
//               <input
//                 className="bg-white opacity-80 h-45 rounded-full border border-[#005D6E] focus:border-blue-500 w-full md:pl-10 basis-[37%]"
//                 placeholder="Order Number"
//                 value={trackingNumber}
//                 onChange={(e) => setTrackingNumber(e.target.value)}
//               />

//               <div>
//                 <SecondaryButton label="Track" onClick={handleTrackOrder} />
//               </div>
//             </div>

//             <div className="w-full md:px-20">
//               {loading ? (
//                 <div className="flex justify-center items-center h-48 bg-white bg-opacity-80 rounded-xl">
//                   <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-teal-700"></div>
//                 </div>
//               ) : orderStatuses ? (
//                 <div className="bg-white bg-opacity-80 p-6 rounded-xl shadow-sm">
//                   <h3 className="text-lg font-semibold text-teal-800 mb-4">Order Status</h3>

//                   <div className="relative pb-2 md:hidden">

//                     <div className="absolute left-6 top-0 bottom-0 w-1 bg-gray-200 z-0"></div>

//                     <div className="relative z-10">
//                       {steps.map((step, index) => {
//                         const currentStep = getCurrentStep();
//                         const isCompleted = index <= currentStep;
//                         const isActive = index === currentStep;

//                         return (
//                           <div
//                             key={index}
//                             className={`flex items-start mb-6 last:mb-0 ${isCompleted ? "" : "opacity-60"}`}
//                           >
//                             <div className={`
//                               relative flex items-center justify-center w-12 h-12 rounded-full shrink-0
//                               ${isCompleted
//                                 ? "bg-teal-600 text-white"
//                                 : "bg-gray-200 text-gray-500"
//                               }
//                               ${isActive ? "ring-4 ring-teal-100" : ""}
//                             `}>
//                               {step.icon}
//                             </div>

//                             <div className="ml-4 flex-grow">
//                               <h4 className={`text-base font-semibold ${isActive ? "text-teal-800" : "text-gray-700"}`}>
//                                 {step.title}
//                               </h4>
//                               <p className="text-sm text-gray-600 mt-1">
//                                 {step.description}
//                               </p>
//                               {isCompleted && index < steps.length - 1 && (
//                                 <div className="mt-2 text-xs text-teal-700">
//                                   {index === currentStep ? "Current status" : "Completed"}
//                                 </div>
//                               )}
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>

//                   <div className="hidden md:block">
//                     <div className="relative">

//                       <div className="absolute top-6 left-0 right-0 h-1 bg-gray-200 z-0"></div>

//                       {/* Steps */}
//                       <div className="flex justify-between relative z-10">
//                         {steps.map((step, index) => {
//                           const currentStep = getCurrentStep();
//                           const isCompleted = index <= currentStep;
//                           const isActive = index === currentStep;

//                           return (
//                             <div
//                               key={index}
//                               className={`flex flex-col items-center text-center max-w-xs px-2 ${isCompleted ? "" : "opacity-60"}`}
//                             >
//                               <div className={`
//                                 relative flex items-center justify-center w-12 h-12 rounded-full
//                                 ${isCompleted
//                                   ? "bg-teal-600 text-white"
//                                   : "bg-gray-200 text-gray-500"
//                                 }
//                                 ${isActive ? "ring-4 ring-teal-100" : ""}
//                                 mb-3
//                               `}>
//                                 {step.icon}
//                               </div>

//                               <h4 className={`text-sm font-semibold ${isActive ? "text-teal-800" : "text-gray-700"}`}>
//                                 {step.title}
//                               </h4>

//                               <p className="text-xs text-gray-600 mt-1 hidden lg:block">
//                                 {step.description}
//                               </p>

//                               {isCompleted && (
//                                 <div className="mt-2 text-xs text-teal-700">
//                                   {index === currentStep ? "Current" : ""}
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         })}
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 error && (
//                   <div className="p-4 bg-red-50 text-red-700 rounded-xl border border-red-200">
//                     {error}
//                   </div>
//                 )
//               )}
//             </div>
//           </div>
//         </div>
//       </section>
//       <Footer />
//     </div>
//     </>
//   );
// };

// export default TrackOrder;
